// DAS-65 Phase 1 + DAS-70 Wave-A: VariantGate — context 값에 따라 v1/v2/v3 컴포넌트를 렌더한다.
//   v1 = 기존(legacy)
//   v2 = IS 리프레시 (Wave-B/C 에서 실제 포팅)
//   v3 = 정보 구조 재설계 (기존 v2 디렉토리를 rename 한 결과)
//
// prop 미제공 + fallbackToV1=true 이면 v1 재사용, false 이면 DesignReviewNotice 렌더.

import React from 'react';
import { VariantContext } from '../contexts/variant_context';
import DesignReviewNotice from '../components/common/design_review_notice';

/**
 * VariantGate
 * @param {React.ComponentType} v1 - v1 컴포넌트 (필수)
 * @param {React.ComponentType|null} v2 - v2 컴포넌트 (null이면 fallback 처리)
 * @param {React.ComponentType|null} v3 - v3 컴포넌트 (null이면 fallback 처리)
 * @param {boolean} fallbackToV1 - 선택한 variant 컴포넌트 미제공 시 v1 재사용 여부 (기본: true)
 */
const VariantGate = ({ v1: V1, v2: V2, v3: V3, fallbackToV1 = true, ...rest }) => (
    <VariantContext.Consumer>
        {({ variant }) => {
            if (variant === 'v2') {
                if (V2) return <V2 {...rest} />;
                if (fallbackToV1) return <V1 {...rest} />;
                return <DesignReviewNotice />;
            }
            if (variant === 'v3') {
                if (V3) return <V3 {...rest} />;
                if (fallbackToV1) return <V1 {...rest} />;
                return <DesignReviewNotice />;
            }
            return <V1 {...rest} />;
        }}
    </VariantContext.Consumer>
);

export default VariantGate;
